/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';
import { pluralize } from '@utils';

const TabItem = ({ module: { content }, errors, previewImg }) => {
  return (
    <InfoItem.WithError
      description={pluralize(content.sections?.length, 'section')}
      image={previewImg}
      error={errors}
      size="large"
    >
      Tabbed Module
    </InfoItem.WithError>
  );
};

export default TabItem;
